import * as React from 'react';
import { NoTourSupport } from './parts/NoTourSupport';

export interface ITourProps {
  isIE: boolean;
  tourUrl: string;
}

export function Tour(props: ITourProps) {
  const { isIE, tourUrl } = props;

  if (isIE) {
    return <NoTourSupport />;
  }

  return (
    <iframe
      frameBorder={0}
      src={tourUrl}
      width="100%"
      height="100%"
      allowFullScreen
      sandbox="allow-scripts allow-same-origin allow-popups allow-downloads"
    />
  );
}
